// test1708
(1708 && 0);
